module.exports = "/_next/static/images/top_etfs-c448edbe4645283108328862b0d43ce6.jpeg";